import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMPData } from 'src/mentor/services'

const TEACHER_PROFILE_CACHE_TTL_MS = 5 * 60 * 1000
let inFlightTeacherProfileRequest = null
const teacherProfileCache = {
  data: null,
  timestamp: 0,
}

export const getTeacherProfileData = createAsyncThunk(
  'teacher/getProfileData',
  async (
    { forceFetch = false } = {},
    { rejectWithValue, getState, fulfillWithValue, dispatch },
  ) => {
    getTeacherProfileData.pending()
    const { teacherProfileDataStore } = getState()
    const profileData = teacherProfileDataStore?.teacherData?.data

    if (!!profileData) {
      if (forceFetch) {
        dispatch(getTeacherProfileData.fulfilled(profileData))
      } else {
        teacherProfileCache.data = profileData
        teacherProfileCache.timestamp = Date.now()
        return profileData
      }
    }

    const hasFreshCache =
      !forceFetch &&
      teacherProfileCache.data &&
      Date.now() - teacherProfileCache.timestamp < TEACHER_PROFILE_CACHE_TTL_MS
    if (hasFreshCache) {
      return teacherProfileCache.data
    }

    if (!forceFetch && inFlightTeacherProfileRequest) {
      return inFlightTeacherProfileRequest
    }

    inFlightTeacherProfileRequest = getMPData('/api/secure/teacher/profile')
    try {
      const resp = await inFlightTeacherProfileRequest
      if (resp?.status === 200) {
        teacherProfileCache.data = resp?.data
        teacherProfileCache.timestamp = Date.now()
        return resp?.data
      }
      return rejectWithValue(resp.message)
    } finally {
      inFlightTeacherProfileRequest = null
    }
  },
)
